import React from 'react';
import PropTypes from 'prop-types';
import Button from '@zg-rentals/multibrand-ui/lib/Button';
import Row from '@zg-rentals/multibrand-ui/lib/Row';
import Col from '@zg-rentals/multibrand-ui/lib/Col';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import Radio from '@zg-rentals/multibrand-ui/lib/Radio';
import HR from '@zg-rentals/multibrand-ui/lib/HR';

const reasonMap = [
    {
        reason: 'notQualified',
        label: "This person doesn't meet my qualification requirements",
    },
    {
        reason: 'consideringAnother',
        label: "I'm considering another render",
    },
    {
        reason: 'alreadyFound',
        label: 'I already found a tenant',
    },
    {
        reason: 'other',
        label: 'Other',
    },
];

export default class NotInterested extends React.Component {
    static propTypes = {
        onSaveReason: PropTypes.func.isRequired,
    };

    constructor() {
        super();

        this.handleOnSelect = this.handleOnSelect.bind(this);
        this.handleOnSave = this.handleOnSave.bind(this);

        this.state = {
            selected: null,
        };
    }

    handleOnSave(e) {
        const { onSaveReason } = this.props;
        const { selected } = this.state;

        if (e) {
            e.preventDefault();
        }
        onSaveReason(selected);
    }

    handleOnSelect(reason) {
        if (reason !== this.state.selected) {
            this.setState({
                selected: reason,
            });
        }
    }

    render() {
        const { name } = this.props;
        const { selected } = this.state;
        const reasonHeader = `Select a reason and we'll let ${name} know:`;

        return (
            <React.Fragment>
                <Row>
                    <Col>
                        <Text type="h2" className="stacked-sm">
                            Not a Match?
                        </Text>
                    </Col>
                </Row>
                <Row>
                    <Col md={7}>
                        <div className="Inquiry-contact-notinterested-desc">
                            <Col md={9}>
                                <Text inline={true} emphasize={true}>
                                    Why tell us?
                                </Text>
                                <Text inline={true}>
                                    &nbsp;If this person is not the right tenant for you, you can free them up to move
                                    on and inquire about other properties.
                                </Text>
                                <Text className="margin-top-md">
                                    Following up on inquiries also earns you a higher response rating.
                                </Text>
                            </Col>
                            <Col md={3} />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Text className="stacked-lg">{reasonHeader}</Text>
                        <div className="Inquiry-contact-notinterested-reasons">
                            {reasonMap.map(item => (
                                <Radio
                                    key={item.reason}
                                    checked={selected === item.reason}
                                    label={item.label}
                                    id={item.reason}
                                    onChange={this.handleOnSelect}
                                    className="stacked-md"
                                />
                            ))}
                        </div>
                    </Col>
                    <Col md={6}>
                        <HR />
                    </Col>
                    <Col>
                        <div className="Inquiry-contact-notinterested-reasons">
                            <Radio
                                className="stacked-lg"
                                checked={selected === 'reportInquiryAsSpam'}
                                id="reportInquiryAsSpam"
                                label="This inquiry is spam"
                                onChange={this.handleOnSelect}
                            />
                        </div>
                        <Button type="primary" disabled={!selected} onClick={this.handleOnSave}>
                            Save
                        </Button>
                    </Col>
                </Row>
            </React.Fragment>
        );
    }
}
